import { ChangeDetectionStrategy, Component, OnInit, inject, input, signal } from '@angular/core';
import { PowerComponent } from '@/pages/power/power.component';
import { POWER_SERVICE } from 'src/api/power.service.interface';
import { CloudPowerService } from '@/cloud/services/cloud-power.service';

/** Outlets tab of a PDU linked device: the shared Power page scoped to this one device. */
@Component({
    selector: 'app-linked-device-power',
    standalone: true,
    imports: [PowerComponent],
    template: `
        @if (ready()) {
            <app-power [showHeader]="false" />
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [CloudPowerService, { provide: POWER_SERVICE, useExisting: CloudPowerService }]
})
export class LinkedDevicePowerComponent implements OnInit {
    private power = inject(CloudPowerService);
    readonly linkedDeviceId = input.required<string>();
    readonly ready = signal(false);

    ngOnInit(): void {
        this.power.setScope({ kind: 'linkedDevice', linkedDeviceId: this.linkedDeviceId() });
        this.ready.set(true);
    }
}
